export default __webpack_public_path__ + "static/thebottomline24-b883656f03a451afa490fe97673e6b23.jpg";